"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIButtonGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      use = _ref.use,
      orientation = _ref.orientation,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "use", "orientation"]);
  var classes = (0, _classnames.default)('UIButtonGroup', 'private-button__group', className, {
    'private-floating-button-group__buttons private-floating-button-group__buttons--standalone': use === 'floating',
    'private-button__group--horizontal': orientation === 'horizontal',
    'private-button__group--vertical': orientation === 'vertical'
  });
  return _react.default.createElement("div", Object.assign({}, rest, {
    className: classes
  }), children);
}

UIButtonGroup.propTypes = {
  children: _propTypes.default.node,
  use: _propTypes.default.oneOf(['default', 'floating']).isRequired,
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
};
UIButtonGroup.defaultProps = {
  use: 'default',
  orientation: 'horizontal'
};
UIButtonGroup.displayName = 'UIButtonGroup';
var _default = UIButtonGroup;
exports.default = _default;
module.exports = exports.default;